// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-571fbe60]{height:30px}.btn-text[data-v-571fbe60]{font-size:16px;font-weight:500 !important;padding:0 16px;color:#000}.v-input--radio-group__input .mdi-radiobox-blank[data-v-571fbe60]{color:#fff}.v-input--radio-group__input .v-label[data-v-571fbe60]{color:#fff}.header[data-v-571fbe60]{z-index:99}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
